// extracted by mini-css-extract-plugin
export default {"spinnerOverlay":"Spinner_spinnerOverlay__hkxtC","spinner":"Spinner_spinner__H2HDD","load4":"Spinner_load4__eKQiz","rounded":"Spinner_rounded__ygtrX","load8":"Spinner_load8__MoDIZ"};